import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Box,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import TableView from "../../../CustomComponent/TableView";
import {
  addMarkListData,
  getMarkListDataById,
  updateMarkListData,
} from "../../../../service/MarkingServices";

function EditCoursesForm() {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const classes = useStyles();
  const { rowId } = useParams();

  const [courseName, setCourseName] = useState("");
  const [questionCount, setQuestionCount] = useState(0);
  const [totalScore, setTotalScore] = useState("");
  const [markingSystem, setMarkingSystem] = useState("same");
  const [negativeMarking, setNegativeMarking] = useState("");
  const [negativeScore, setNegativeScore] = useState("");
  const [partialMarking, setPartialMarking] = useState("");
  const [tableRowData, setTableRowData] = useState([]);
  console.log("markingSystem", markingSystem, tableRowData);
  useEffect(() => {
    if (negativeMarking === "no") {
      setNegativeScore("0");
    }
  }, [negativeMarking]);
  //my code implement for edit row's time

  const prevTableRowDataRef = useRef([]);

  useEffect(() => {
    if (markingSystem === "different") {
      const count = parseInt(questionCount);

      if (isNaN(count) || count <= 0) {
        // Store current tableRowData before clearing
        if (tableRowData.length > 0) {
          prevTableRowDataRef.current = [...tableRowData];
        }
        setTableRowData([]);
      } else {
        // Create a copy of current or previous table data
        const currentRows =
          tableRowData.length > 0
            ? [...tableRowData]
            : [...prevTableRowDataRef.current];
        const newRows = [];

        // Process each row up to the new count
        for (let i = 0; i < count; i++) {
          if (i < currentRows.length) {
            // Keep existing data but update question number
            newRows.push({
              ...currentRows[i],
              question_no: i + 1,
            });
          } else {
            // Add new blank row
            newRows.push({
              id: -(i + 1), // Temporary negative ID for new rows
              question_no: i + 1,
              mark: "",
              partial_mark: "",
              negative_marking: "",
              negative_mark: "",
            });
          }
        }

        setTableRowData(newRows);
      }
    }
  }, [questionCount, markingSystem, tableRowData.length]);

  useEffect(() => {
    const fetchData = async () => {
      if (rowId) {
        console.log("rowId", rowId);
        try {
          const data = await getMarkListDataById(rowId);
          console.log(data, "RowIdData");
          setCourseName(data?.markingsystemdata?.name);
          setQuestionCount(data?.markingsystemdata?.question_count);
          setTotalScore(data?.markingsystemdata?.total_score);
          setMarkingSystem(
            data?.markingsystemdata?.marking_system !== "differrent"
              ? data?.markingsystemdata?.marking_system
              : "different"
          );
          setPartialMarking(data?.markingsystemdata?.partial_mark);
          setNegativeMarking(data?.markingsystemdata?.negative_marking);
          setNegativeScore(data?.markingsystemdata?.negative_marking_score);
          setTableRowData(data?.markingsystemdata?.markingsystemquestion);
        } catch (error) {
          console.error("Failed to fetch row data:", error);
        }
      }
    };
    fetchData();
  }, []);
  const handleFieldChange = (id, field, value) => {
    setTableRowData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const columns = [
    {
      field: "question_no",
      headerName: "Question No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "mark",
      headerName: "Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(cellValues.row.id, "mark", e.target.value)
              }
              value={cellValues.row.mark || ""}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Marks"
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "partial_mark",
      headerName: "Partial Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "partial_mark",
                  e.target.value
                )
              }
              value={cellValues.row.partial_mark || ""}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Partial Marks"
              // disabled={cellValues.row.question_type !== "Multiple Choice"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "negative_marking",
      headerName: "Negative Marking",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <Select
              labelId="negative-marking-label"
              style={{ width: "100px" }}
              id="negative_marking"
              value={cellValues.row.negative_marking || ""}
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "negative_marking",
                  e.target.value
                )
              }
              displayEmpty
              className={classes.selectEmpty}
              variant="outlined"
            >
              <MenuItem disabled value="">
                Select Option
              </MenuItem>
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
            </Select>
          </div>
        );
      },
    },
    {
      field: "negative_mark",
      headerName: "Negative Mark",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) => {
                let value = e.target.value;

                if (cellValues.row.negative_marking === "yes") {
                  // Allow only digits (no dot for float)
                  value = value.replace(/[^0-9.]/g, "");

                  handleFieldChange(cellValues.row.id, "negative_mark", value);
                } else {
                  handleFieldChange(
                    cellValues.row.id,
                    "negative_mark",
                    e.target.value
                  );
                }
              }}
              value={
                cellValues.row.negative_marking === "yes"
                  ? `-${String(cellValues.row.negative_mark).replace(
                      /^[-]+/,
                      ""
                    )}`
                  : 0
              }
              type="text"
              variant="outlined"
              required
              placeholder="Enter Negative Mark"
              disabled={cellValues.row.negative_marking !== "yes"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
  ];

  const style = [
    {
      height: "h40vh",
      style: "viewtable",
    },
  ];
  const perQuestionMark =
    questionCount && totalScore
      ? (parseFloat(totalScore) / parseInt(questionCount)).toFixed(2)
      : "";

  const handleClose = () => navigate("/admin/markingsystem");

  const handleFormSubmit = async () => {
    if (!courseName.trim()) {
      toast.warn("Please enter a Mark name.");
      return;
    }

    if (!questionCount || !totalScore) {
      toast.warn("Please enter valid Question Count and Total Score.");
      return;
    }
    if (markingSystem == "same" && negativeScore?.length === 0) {
      toast.warn("Please enter a Nagative Marking.");
      return;
    }
    const finalData = {
      MarkingSystem: {
        id: rowId,
        name: courseName,
        question_count: parseInt(questionCount),
        total_score: parseFloat(totalScore),
      },
    };

    if (markingSystem === "same") {
      // Default negativeMarking to "no" if not selected
      const negativeOption = negativeMarking || "no";

      finalData.MarkingSystem.marking_system = "same";
      // finalData.MarkingSystem.partial_mark = partialMarking;
      finalData.MarkingSystem.per_question_mark =
        parseFloat(perQuestionMark) || 0;
      finalData.MarkingSystem.negative_marking = negativeOption;
      finalData.MarkingSystem.negative_marking_score =
        negativeOption === "yes" ? parseFloat(negativeScore) || 0 : 0;
    } else {
      finalData.MarkingSystem.marking_system = "differrent";
      console.log(tableRowData, "tableRowData");
      finalData.MarkingSystem.question_data = tableRowData.map((row) => ({
        id: row.id,
        question_no: row.question_no,
        mark: parseFloat(row.mark) || 0,
        partial_mark: parseFloat(row.partial_mark) || 0,
        // question_type: row.question_type || "Multiple Choice",
        negative_marking: row.negative_marking || "no",
        negative_mark:
          row.negative_marking === "yes"
            ? parseFloat(row.negative_mark) || 0
            : 0,
      }));
    }
    console.log("Final Form Data", finalData);
    try {
      const response = await updateMarkListData(finalData);
      if (response?.success) {
        toast.success("Marking update successfully!");
        setTimeout(() => {
          navigate("/admin/markingsystem");
        }, 1500);
      }

      console.log("API Response:", response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
              >
                Edit Marking Details
              </Typography>

              {/* Course Name */}
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel className={`${classes.textcolorformlabel}`}>
                  Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Name"
                />
              </div>

              {/* Question Count */}
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel className={`${classes.textcolorformlabel}`}>
                  Question Count <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={questionCount}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/, "");
                    setQuestionCount(value);
                  }}
                  type="number"
                  variant="outlined"
                  required
                  placeholder="Enter Question Count"
                />
              </div>

              {/* Total Score */}
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel className={`${classes.textcolorformlabel}`}>
                  Total Score <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={totalScore}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/, "");
                    setTotalScore(value);
                  }}
                  type="number"
                  variant="outlined"
                  required
                  placeholder="Enter Total Score"
                />
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              {/* Marking System */}
              <Typography className={`${classes.w24}`}></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel className={`${classes.textcolorformlabel}`}>
                  Marking System Name{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <RadioGroup
                  row
                  value={markingSystem}
                  onChange={(e) => setMarkingSystem(e.target.value)}
                  className={`${classes.radiocolor}`}
                >
                  <FormControlLabel
                    value="same"
                    control={<Radio />}
                    label="Same"
                  />
                  <FormControlLabel
                    value="different"
                    control={<Radio />}
                    label="Different"
                  />
                </RadioGroup>
              </div>

              {/* Conditional Fields */}
              {markingSystem === "same" ? (
                <>
                  {/* Per Question Mark (Disabled & Auto calculated) */}
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel className={`${classes.textcolorformlabel}`}>
                      Per Question Mark
                    </FormLabel>
                    <TextField
                      value={perQuestionMark ? `${perQuestionMark} marks` : ""}
                      disabled
                      variant="outlined"
                      placeholder="Auto Calculated"
                    />
                  </div>

                  {/* Negative Marking */}
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel className={`${classes.textcolorformlabel}`}>
                      Negative Marking{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      value={negativeMarking}
                      onChange={(e) => setNegativeMarking(e.target.value)}
                      displayEmpty
                      variant="outlined"
                      className={classes.selectEmpty}
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </Select>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    {/* <Typography variant="body1">Hello</Typography> */}
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </>
              )}
            </div>

            {/* Negative Marking Score */}
            {markingSystem === "same" && (
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography className={`${classes.w24}`}></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                >
                  <FormLabel className={`${classes.textcolorformlabel}`}>
                    Negative Marking Score{" "}
                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  {/* <TextField
                    value={negativeScore}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[-]?\d*\.?\d*$/.test(value)) {
                        setNegativeScore(value);
                      }
                    }}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Type Here"
                    disabled={negativeMarking === "no" || !negativeMarking}
                  /> */}
                  <TextField
                    value={
                      negativeMarking === "no" || !negativeMarking
                        ? negativeScore
                        : `-${String(negativeScore).replace(/^[-]+/, "")}` // display with single `-`
                    }
                    onChange={(e) => {
                      let value = e.target.value;

                      if (negativeMarking === "no" || !negativeMarking) {
                        // Store only digits (positive integer)
                        value = value.replace(/[^0-9.]/g, "");
                        setNegativeScore(value);
                      } else {
                        // Store only digits (without dot, for integer input)
                        value = value.replace(/[^0-9.]/g, "");
                        setNegativeScore(value);
                      }
                    }}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Type Here"
                    disabled={negativeMarking === "no" || !negativeMarking}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                >
                  {/* <FormLabel className={`${classes.textcolorformlabel}`}>
                    partial marking{" "}
                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    value={partialMarking}
                    onChange={(e) => {
                      setPartialMarking(e.target.value);
                    }}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Type Here"
                    // disabled={negativeMarking === "no" || !negativeMarking}
                  /> */}
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                ></div>
              </div>
            )}
          </div>
          {markingSystem === "different" && (
            <div style={{ marginTop: "1%" }}>
              <TableView
                columns={columns}
                rows={tableRowData}
                Heading={style}
              />
            </div>
          )}
          {/* Buttons */}
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleClose}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}

export default EditCoursesForm;
